// Scale > Scale
import React from 'react'
import styled from 'styled-components'
import { range } from '../utils/Number'
import { ScaleProps } from './index'
import ScaleLabel from '../ScaleLabel'

const ScaleRoot = styled.div`
	position: -webkit-sticky;
	position: sticky;
	left: 0px;
	min-width: 36px;
	padding: 38px ${({ theme }) => theme.spacing.unit}px 0px;
	border-right: 1px solid ${({ theme }) => theme.palette.accent.neutral};
	background-color: white;
	z-index: 2;
`

export default class Scale extends React.PureComponent<ScaleProps> {
	render() {
		const { dataScale, labelFrequency, labelConverter } = this.props

		// TODO
		// this only works if the dataScale starts at 0 and has an increment of 1
		const r = range(dataScale.min, dataScale.max, false)
		const rLength = r.length + 1
		const labelInc = dataScale.totalIncrements / (rLength + 1)

		return (
			<ScaleRoot>
				{r.map(
					(v: number, ix: number) =>
						v % labelFrequency === 0 || v === 0 ? (
							<ScaleLabel
								key={v}
								index={ix}
								numLabels={rLength}
								labelFrequency={labelFrequency}
								labelInc={labelInc}
								total={dataScale.totalIncrements}
							>
								{labelConverter(v)}
							</ScaleLabel>
						) : (
							undefined
						)
				)}
			</ScaleRoot>
		)
	}
}
